/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import s from './ModalAlert.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

const ModalAlert = (props) => {
  return (
    <Modal {...props} >
      <Modal.Header className="bg-warning" closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.bodyText}
        <br /><br />
        <Button className="btn btn-warning pull-right" onClick={props.onHide}>Zamknij</Button>
        <br /><br />
      </Modal.Body>
    </Modal>
  );
};

export default withStyles(s)(ModalAlert);


// WEBPACK FOOTER //
// src/components/Modals/ModalAlert/ModalAlert.js